import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { eur, monthLabel } from "./format";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ImportInvoicesButton = ({ onImported, variant = "header" }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const token = localStorage.getItem("token");
      const res = await axios.post(`${API}/sales/invoices/import`, form, {
        withCredentials: true,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      const months = res.data.months || [];
      toast.success(`Imported ${res.data.rows} invoice${res.data.rows === 1 ? "" : "s"}`, {
        description: months.map((m) => `${monthLabel(m.month, "short")}: ${m.count} · ${eur(m.net)} net${m.credit_notes ? ` · ${m.credit_notes} CN` : ""}`).join("  ·  "),
      });
      if (res.data.warnings?.length) toast.warning(`${res.data.warnings.length} line(s) could not be read`, { description: res.data.warnings[0] });
      onImported?.(months);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Import failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const cls = variant === "header"
    ? "flex items-center gap-2 rounded-xl bg-emerald-500/15 px-3.5 py-2.5 text-sm font-semibold text-emerald-300 ring-1 ring-emerald-500/30 hover:bg-emerald-500/25 disabled:opacity-60"
    : "inline-flex items-center gap-2 rounded-lg bg-emerald-500 px-4 py-2 text-sm font-bold text-slate-950 hover:bg-emerald-400 disabled:opacity-60";

  return (
    <>
      <input ref={inputRef} type="file" accept=".pdf,.csv,application/pdf,text/csv" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="invoice-import-input" />
      <button onClick={() => inputRef.current?.click()} disabled={busy} className={cls} data-testid={`invoice-import-btn-${variant}`} title="Upload the PrintLogic 'Invoices Issued' report (PDF or CSV)">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} Import invoice report
      </button>
    </>
  );
};
